/**
 * Helper functions to save and retrieve the return path before logout
 */

import { publicRoutes } from '../constants/route';

const RETURN_PATH_KEY = 'returnPath';

/**
 * Check if a path is a public route
 * @param {string} path - The path to check
 * @returns {boolean} True if the path is a public route
 */
const isPublicRoute = (path) => {
    // Remove query string for comparison
    const pathWithoutQuery = path.split('?')[0];
    return publicRoutes.some(route => {
        // Handle exact matches and route patterns
        if (route === pathWithoutQuery) return true;
        // Handle dynamic routes like /contracts/:id
        if (route.includes(':')) {
            const routePattern = route.replace(/:[^/]+/g, '[^/]+');
            const regex = new RegExp(`^${routePattern}$`);
            return regex.test(pathWithoutQuery);
        }
        return false;
    });
};

/**
 * Save the current path to localStorage
 * @param {string} path - The path to save (defaults to current location)
 */
export const saveReturnPath = (path = null) => {
    const pathToSave = path || window.location.pathname + window.location.search;
    // Don't save login page or public routes
    if (pathToSave === '/login' || pathToSave.startsWith('/login') || isPublicRoute(pathToSave)) {
        return;
    }
    localStorage.setItem(RETURN_PATH_KEY, pathToSave);
};

/**
 * Get and remove the saved return path from localStorage
 * @returns {string|null} The saved path or null if not found
 */
export const getReturnPath = () => {
    const path = localStorage.getItem(RETURN_PATH_KEY);
    if (path) {
        localStorage.removeItem(RETURN_PATH_KEY);
        return path;
    }
    return null;
};

/**
 * Clear the saved return path
 */
export const clearReturnPath = () => {
    localStorage.removeItem(RETURN_PATH_KEY);
};

